import { render, staticRenderFns } from "./companyInformationProperty.vue?vue&type=template&id=30164e86"
import script from "./companyInformationProperty.vue?vue&type=script&lang=js"
export * from "./companyInformationProperty.vue?vue&type=script&lang=js"
import style0 from "./companyInformationProperty.vue?vue&type=style&index=0&id=30164e86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports